import { defineMessages } from 'react-intl';

export default defineMessages({
    TopMakes: {
        id: 'spm.components.vehicleLookup.topMakes',
        defaultMessage: '---- Top 10 Makes ----'
    },
    AllMakes: {
        id: 'spm.components.vehicleLookup.allMakes',
        defaultMessage: '---- All makes ----'
    },
    PleaseSelect: {
        id: 'spm.components.vehicleLookup.pleaseSelect',
        defaultMessage: 'Please select...'
    }
});
